import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generateImageUrl } from '@guryou/html-components';
import UserImageForm from './UserImageForm';
import Modal from '../../components/shared/Modal';

const UserImage = ({ acc }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <div className="flex items-center gap-4">
      <div className={`h-16 w-16 rounded-full ring-2 ring-[var(--feel-primary)] overflow-hidden flex items-center justify-center bg-gray-100`}>
        <img src={generateImageUrl(acc.image)} alt="User avatar" className="h-full w-full object-cover object-center" />
      </div>
      <button
        type="button"
        onClick={open}
        className={`inline-flex items-center justify-center rounded-lg px-4 py-2 text-white bg-[var(--feel-primary)] hover:opacity-90 focus:outline-none focus:ring-4 focus:ring-[var(--feel-primary)] transition`}
      >
        {t('GENERAL.changeAvatar')}
      </button>

      <Modal isOpen={isOpen} onClose={close} title={t('GENERAL.changeAvatar')}>
        <div className="p-6">
          <UserImageForm onClose={close} />
        </div>
      </Modal>
    </div>
  );
};

export default UserImage;
